import React from "react";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import SimpleTooltip from "components/common/SimpleTooltip";
import UprTargetingPopover from "../custom-upr/UprTargetingPopover";
import FirstLookPriceSection from "components/network/pricing-rules/first-look-rules/FirstLookPriceSection";
import PriorityControl from "./PriorityControl";

import { FiCheckCircle, FiXCircle, FiFileText } from "react-icons/fi";

class FirstLookSettingTable extends React.Component {
  render() {
    const {
      popupId,
      items,
      units,
      virtualPlacements,
      placements,
      networkId,
      currency,
      selectedItems = [],
      handleSelect,
      allItems,
      customRules,
      handleOpenEdit,
      handleOpenEditJSON,
      handleOpenChangeLog,
      handleRemoveRule,
      handleOpenDuplicate,
      handlePriorityChange,
      handleToggleStatus,
      handlePopupIdChange,
      readOnly = false,
      place,
    } = this.props;

    const enabledRules = _.filter(
      customRules,
      (rule) => rule.enabled || _.isNil(rule.enabled)
    );

    const priorityOption = new Array(enabledRules.length)
      .fill(null)
      .map((_, idx) => ({
        value: idx + 1,
        label: idx + 1,
      }));

    function handleSelectItem(itemId) {
      const tempList = [...selectedItems];
      if (itemId === "ALL") {
        const itemsList = _.map(items, (item) => item.id);
        const allItemsList = _.map(allItems, (item) => item.id);
        const newList = isAll()
          ? _.filter(tempList, (id) => !allItemsList.includes(id))
          : _.union(selectedItems, itemsList);
        handleSelect(newList);
        return;
      }

      const newList = tempList.includes(itemId)
        ? _.without(tempList, itemId)
        : [...tempList, itemId];
      handleSelect(newList);
    }

    function isAll() {
      if (!items || items.length === 0) return false;
      return (
        _.filter(items, (item) => {
          return selectedItems.indexOf(item.id) !== -1;
        }).length === items.length
      );
    }

    return (
      <div>
        <table className="border shadow table w-full text-sm">
          <thead className="border-b bg-gray-200 text-xs text-blue-800">
            <tr>
              {!readOnly && (
                <th className="px-2 text-center" style={{ width: "35px" }}>
                  <input
                    style={{
                      width: "18px",
                      height: "18px",
                      marginTop: "4px",
                    }}
                    type="checkbox"
                    checked={isAll()}
                    onChange={() => handleSelectItem("ALL")}
                  ></input>
                </th>
              )}
              <th className="border w-24 py-1">Priority</th>
              <th className="border w-32 px-2 py-1">Enabled</th>
              <th className="border px-2 py-1 text-right">ID</th>
              <th className="border px-2 py-1"></th>
              <th
                className="border px-2 py-1 text-right"
                style={{ width: "60%" }}
              >
                Name
              </th>
              <th className="border px-2 py-1 text-center">Targeting</th>
              <th className="border px-2 py-1 text-right">Est. Criteria</th>
              <th className="border px-2 py-1 text-right">Prices</th>
              {!readOnly && (
                <th
                  className="border px-2 py-1 text-right"
                  style={{ width: "252px" }}
                >
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white text-gray-900">
            {(items || []).map((item, idx) => {
              const { targetingSection } = item;
              const countItem = {
                unitIds: _.get(targetingSection, ["inventory", "unitIds"], [])
                  .length,
                excludedUnitIds: _.get(
                  targetingSection,
                  ["inventory", "excludedUnitIds"],
                  []
                ).length,
                placementIds: _.get(
                  targetingSection,
                  ["inventory", "placementIds"],
                  []
                ).length,
                virtualPlacementIds: _.get(
                  targetingSection,
                  ["inventory", "virtualPlacementIds"],
                  []
                ).length,
                os: (
                  (targetingSection &&
                    targetingSection.os &&
                    (targetingSection.os.excludes ||
                      targetingSection.os.includes)) ||
                  []
                ).length,
                deviceCategory: (
                  (targetingSection &&
                    targetingSection.deviceCategory &&
                    (targetingSection.deviceCategory.excludes ||
                      targetingSection.deviceCategory.includes)) ||
                  []
                ).length,
                country: (
                  (targetingSection &&
                    targetingSection.country &&
                    (targetingSection.country.excludes ||
                      targetingSection.country.includes)) ||
                  []
                ).length,
                mobileApplication: (
                  (targetingSection &&
                    targetingSection.mobileApplication &&
                    (targetingSection.mobileApplication.excludes ||
                      targetingSection.mobileApplication.includes)) ||
                  []
                ).length,
                inventoryUrl: (
                  (targetingSection &&
                    targetingSection.inventoryUrl &&
                    (targetingSection.inventoryUrl.excludes ||
                      targetingSection.inventoryUrl.includes)) ||
                  []
                ).length,
                inventorySize: (
                  (targetingSection &&
                    targetingSection.inventorySize &&
                    (targetingSection.inventorySize.excludes ||
                      targetingSection.inventorySize.includes)) ||
                  []
                ).length,
                customs: (
                  (targetingSection && targetingSection.customs) ||
                  []
                ).reduce((acc, list) => {
                  return (
                    acc +
                    list.reduce((acc2, d) => {
                      return acc2 + d.valueIds.length;
                    }, 0)
                  );
                }, 0),
              };

              const priority = _.findIndex(enabledRules, { id: item.id }) + 1;

              return (
                <HighLightRowWrapper
                  key={`${item.id}-${idx}`}
                  selected={popupId === item.id}
                >
                  {!readOnly && (
                    <td className="px-2 text-center">
                      <input
                        style={{
                          width: "18px",
                          height: "18px",
                          marginTop: "4px",
                        }}
                        type="checkbox"
                        checked={selectedItems.indexOf(item.id) !== -1}
                        onChange={() => handleSelectItem(item.id)}
                      ></input>
                    </td>
                  )}

                  <td className="border py-1 text-center">
                    {!readOnly && item.enabled !== false && (
                      <PriorityControl
                        value={priority}
                        options={priorityOption}
                        onChange={(val) => {
                          handlePopupIdChange(item.id);
                          handlePriorityChange(item.id, val);
                        }}
                      ></PriorityControl>
                    )}
                    {readOnly &&
                      (item.enabled === true || _.isNil(item.enabled)) && (
                        <span>{priority}</span>
                      )}
                  </td>
                  <td className="border px-2 py-1 text-center">
                    <div className="flex items-center justify-center text-center text-lg">
                      {item.enabled || _.isNil(item.enabled) ? (
                        <span className="text-green-600">
                          <FiCheckCircle></FiCheckCircle>
                        </span>
                      ) : (
                        <span className="text-red-600">
                          <FiXCircle></FiXCircle>
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="border px-2 py-1 text-right">
                    <span
                      className={`font-mono ${
                        popupId === item.id ? "font-semibold" : ""
                      }`}
                    >
                      {item.id}
                    </span>
                  </td>
                  <td className="border px-2 py-1">
                    <SimpleTooltip tooltipText="View Change Logs">
                      <button
                        type="button"
                        className="text-gray-600 hover:text-blue-600"
                        onClick={() => handleOpenChangeLog(item)}
                      >
                        <FiFileText></FiFileText>
                      </button>
                    </SimpleTooltip>
                  </td>

                  <td
                    className={`border break-all px-2 py-1 text-right font-medium ${
                      popupId === item.id ? "font-semibold" : ""
                    }`}
                  >
                    {item.name}
                    <div className="flex items-center justify-end gap-1">
                      {item.label && (
                        <div className="text-xs text-gray-600">
                          Label: {item.label}
                        </div>
                      )}
                      {item.description && (
                        <SimpleTooltip
                          tooltipText={
                            <div className="flex w-48 flex-col items-center">
                              <div className="whitespace-normal break-all">
                                Description: {item.description}
                              </div>
                            </div>
                          }
                        >
                          <span className="text-blue-600">
                            <FiFileText></FiFileText>
                          </span>
                        </SimpleTooltip>
                      )}
                    </div>
                  </td>

                  <td className="border px-2 py-1 text-center">
                    <UprTargetingPopover
                      id={item.id}
                      name={item.name}
                      networkId={networkId}
                      targetingSection={item.targetingSection}
                      units={units}
                      virtualPlacements={virtualPlacements}
                      placements={placements}
                      place={place}
                      triggerElement={
                        <div>
                          <button
                            data-tip
                            data-for={item.id + item.name}
                            type="button"
                            className="rounded bg-blue-100 px-4 py-2 font-semibold text-blue-600 hover:bg-blue-200"
                          >
                            {Object.keys(item.targetingSection).length}
                          </button>
                          {Object.keys(item.targetingSection).length > 0 && (
                            <ReactTooltip
                              id={item.id + item.name}
                              type="dark"
                              effect="solid"
                            >
                              {Object.keys(item.targetingSection).join(", ")}
                            </ReactTooltip>
                          )}
                        </div>
                      }
                      onOpen={() => handlePopupIdChange(item.id)}
                      onClose={() => handlePopupIdChange("")}
                    ></UprTargetingPopover>
                  </td>

                  <td className="border px-2 py-1 text-right font-medium">
                    <SimpleTooltip
                      tooltipText={
                        <>
                          {_.sum(_.values(countItem)) > 0
                            ? _.keys(countItem)
                                .filter((key) => countItem[key] > 0)
                                .map((key) => (
                                  <div
                                    className="flex justify-between gap-2"
                                    key={key}
                                  >
                                    <span>{_.startCase(key)}: </span>
                                    <span>{countItem[key]}</span>
                                  </div>
                                ))
                            : "--"}
                        </>
                      }
                    >
                      {_.sum(_.values(countItem))}
                    </SimpleTooltip>
                  </td>

                  <td className="whitespace-no-wrap border px-2 py-1 text-right">
                    <FirstLookPriceSection
                      item={item.priceSection}
                      networkId={networkId}
                      currency={currency}
                      place={place}
                      onOpen={() => handlePopupIdChange(item.id)}
                      onClose={() => handlePopupIdChange("")}
                    ></FirstLookPriceSection>
                  </td>

                  {!readOnly && (
                    <td className="whitespace-no-wrap border px-2 py-1 text-right">
                      <div className="flex items-center justify-end gap-4">
                        {item.enabled || _.isNil(item.enabled) ? (
                          <button
                            type="button"
                            className="text-blue-600 hover:underline"
                            onClick={() => {
                              handlePopupIdChange("");
                              handleToggleStatus({ ...item, enabled: false });
                            }}
                          >
                            Disable
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="text-blue-600 hover:underline"
                            onClick={() => {
                              handlePopupIdChange("");
                              handleToggleStatus({ ...item, enabled: true });
                            }}
                          >
                            Enable
                          </button>
                        )}
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => {
                            handlePopupIdChange("");
                            handleOpenEdit(item);
                          }}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => handleOpenEditJSON(item)}
                        >
                          JSON
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => {
                            handlePopupIdChange("");
                            handleOpenDuplicate(item);
                          }}
                        >
                          Duplicate
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:text-red-600 hover:underline"
                          onClick={() => {
                            handlePopupIdChange("");
                            handleRemoveRule(item);
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    </td>
                  )}
                </HighLightRowWrapper>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default FirstLookSettingTable;
